import React, { useEffect, useMemo, useState } from "react";
import { SidePanelFormControl } from "spark-core-dx/components";

const EntityFieldEditDialog = ({ open, field, fieldItemMetadata, onCancel, onSave }) => {
  const [editItemData, setEditItemData] = useState(null);

  useEffect(() => {
    if (field?.raw) setEditItemData({ ...field.raw });
    else setEditItemData(null);
  }, [field]);

  const formFields = useMemo(() => {
    return Array.isArray(fieldItemMetadata?.Fields) ? fieldItemMetadata.Fields : [];
  }, [fieldItemMetadata]);

  const title = useMemo(() => {
    const name = field?.displayName || field?.fieldName || "Field";
    return `Edit: ${name}`;
  }, [field]);

  if (!fieldItemMetadata) return null;

  return (
    <SidePanelFormControl
      key={(editItemData?._id ?? editItemData?.UniqueId ?? field?.id ?? "field-edit") + (open ? "-open" : "-closed")}
      open={open}
      title={title}
      metadata={fieldItemMetadata}
      formFields={formFields}
      itemData={editItemData}
      onSave={onSave}
      onCancel={onCancel}
      onUpdateSidePanel={() => {}}
      setOpenEditSidePanel={(value) => {
        if (!value) onCancel();
      }}
      setItemData={setEditItemData}
      onAnimationEnd={(event) => {
        if (editItemData && open && event.animationName === "sidePanelExit") {
          setEditItemData(null);
        }
      }}
      viewOnly={false}
    />
  );
};

export default EntityFieldEditDialog;
